// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { BaseScheduleSubmissionModalLayoutCoachFragmentDoc } from './BaseScheduleSubmissionModalLayout.generated';
import {
  BaseScheduleModalLayoutCoachingSessionFragmentDoc,
  BaseScheduleModalLayoutOrderFragmentDoc,
  BaseScheduleModalLayoutRecurringCadenceFragmentDoc,
} from './BaseScheduleModalLayout.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SchedulingSuccessModalCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
};

export type SchedulingSuccessModalCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  endAt: number;
  durationInMinute: number;
  content:
    | {
        __typename: 'BootcampSession';
        bootcamp: { __typename?: 'Bootcamp'; id: string; title: string };
      }
    | { __typename: 'Class'; id: string; name?: string | null }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
  recurringSession?: { __typename?: 'RecurringSession'; id: string } | null;
};

export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutationVariables =
  Types.Exact<{
    createCoachingSessionByApplicantInput: Types.CoachingSessionInputByApplicant;
    categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
    message?: Types.InputMaybe<Types.Scalars['String']['input']>;
    recurringSessionInput?: Types.InputMaybe<Types.RecurringSessionInput>;
  }>;

export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutation = {
  __typename?: 'Mutation';
  createCoachingSessionByApplicant: {
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    attendees?: Array<{ __typename?: 'Applicant'; id: string }> | null;
    coach: {
      __typename?: 'Coach';
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
    };
  };
};

export type SchedulingSuccessModalUpdateCoachingSessionMutationVariables =
  Types.Exact<{
    id: Types.Scalars['CoachingSessionUrn']['input'];
    input: Types.CoachingSessionPatchInput;
    message?: Types.InputMaybe<Types.Scalars['String']['input']>;
    recurringSessionInput?: Types.InputMaybe<Types.RecurringSessionPatchInput>;
  }>;

export type SchedulingSuccessModalUpdateCoachingSessionMutation = {
  __typename?: 'Mutation';
  updateCoachingSession: { __typename?: 'CoachingSession'; id: string };
};

export type SchedulingSuccessModalRequestIntroMessageMutationVariables =
  Types.Exact<{
    coachUrn: Types.Scalars['CoachUrn']['input'];
    message: Types.Scalars['String']['input'];
    categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
    interest: Types.IntroCallInterest;
    introCallRequested: Types.Scalars['Boolean']['input'];
    coachingSession?: Types.InputMaybe<Types.CoachingSessionInputByApplicant>;
    packageUrns?: Types.InputMaybe<
      | Array<Types.Scalars['PackageUrn']['input']>
      | Types.Scalars['PackageUrn']['input']
    >;
  }>;

export type SchedulingSuccessModalRequestIntroMessageMutation = {
  __typename?: 'Mutation';
  requestIntroMessage: {
    __typename?: 'Order';
    id: string;
    coach: {
      __typename?: 'Coach';
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
      } | null;
    };
    coachingSessions?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
      createdAt: number;
    }> | null;
  };
};

export type SchedulingSuccessModalAssignPendingOrderMutationVariables =
  Types.Exact<{
    coachUrn: Types.Scalars['CoachUrn']['input'];
    orderUrn: Types.Scalars['OrderUrn']['input'];
  }>;

export type SchedulingSuccessModalAssignPendingOrderMutation = {
  __typename?: 'Mutation';
  assignPendingOrder: { __typename?: 'Order'; id: string };
};

export const SchedulingSuccessModalCoachFragmentDoc = gql`
  fragment SchedulingSuccessModal_Coach on Coach {
    id
    user {
      id
      firstName
      lastName
      pictureLink
    }
    slug
    ...BaseScheduleSubmissionModalLayout_Coach
  }
  ${BaseScheduleSubmissionModalLayoutCoachFragmentDoc}
`;
export const SchedulingSuccessModalCoachingSessionFragmentDoc = gql`
  fragment SchedulingSuccessModal_CoachingSession on CoachingSession {
    id
    content {
      ... on OneOnOneSession {
        title
      }
    }
    ...BaseScheduleModalLayout_CoachingSession
  }
  ${BaseScheduleModalLayoutCoachingSessionFragmentDoc}
`;
export const SchedulingSuccessModalCreateCoachingSessionByApplicantDocument = gql`
  mutation SchedulingSuccessModal_createCoachingSessionByApplicant(
    $createCoachingSessionByApplicantInput: CoachingSessionInputByApplicant!
    $categoryUrn: CategoryUrn
    $message: String
    $recurringSessionInput: RecurringSessionInput
  ) {
    createCoachingSessionByApplicant(
      categoryUrn: $categoryUrn
      input: $createCoachingSessionByApplicantInput
      recurringSessionInput: $recurringSessionInput
      message: $message
    ) {
      id
      attendees {
        id
      }
      startAt
      coach {
        availability {
          nextAvailableAt
        }
      }
    }
  }
`;
export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutationFn =
  Apollo.MutationFunction<
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutation,
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutationVariables
  >;

/**
 * __useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation__
 *
 * To run a mutation, you first call `useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulingSuccessModalCreateCoachingSessionByApplicantMutation, { data, loading, error }] = useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation({
 *   variables: {
 *      createCoachingSessionByApplicantInput: // value for 'createCoachingSessionByApplicantInput'
 *      categoryUrn: // value for 'categoryUrn'
 *      message: // value for 'message'
 *      recurringSessionInput: // value for 'recurringSessionInput'
 *   },
 * });
 */
export function useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutation,
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutation,
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutationVariables
  >(SchedulingSuccessModalCreateCoachingSessionByApplicantDocument, options);
}
export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutationHookResult =
  ReturnType<
    typeof useSchedulingSuccessModalCreateCoachingSessionByApplicantMutation
  >;
export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutationResult =
  Apollo.MutationResult<SchedulingSuccessModalCreateCoachingSessionByApplicantMutation>;
export type SchedulingSuccessModalCreateCoachingSessionByApplicantMutationOptions =
  Apollo.BaseMutationOptions<
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutation,
    SchedulingSuccessModalCreateCoachingSessionByApplicantMutationVariables
  >;
export const SchedulingSuccessModalUpdateCoachingSessionDocument = gql`
  mutation SchedulingSuccessModal_UpdateCoachingSession(
    $id: CoachingSessionUrn!
    $input: CoachingSessionPatchInput!
    $message: String
    $recurringSessionInput: RecurringSessionPatchInput
  ) {
    updateCoachingSession(
      id: $id
      input: $input
      message: $message
      recurringSessionInput: $recurringSessionInput
    ) {
      id
    }
  }
`;
export type SchedulingSuccessModalUpdateCoachingSessionMutationFn =
  Apollo.MutationFunction<
    SchedulingSuccessModalUpdateCoachingSessionMutation,
    SchedulingSuccessModalUpdateCoachingSessionMutationVariables
  >;

/**
 * __useSchedulingSuccessModalUpdateCoachingSessionMutation__
 *
 * To run a mutation, you first call `useSchedulingSuccessModalUpdateCoachingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulingSuccessModalUpdateCoachingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulingSuccessModalUpdateCoachingSessionMutation, { data, loading, error }] = useSchedulingSuccessModalUpdateCoachingSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      message: // value for 'message'
 *      recurringSessionInput: // value for 'recurringSessionInput'
 *   },
 * });
 */
export function useSchedulingSuccessModalUpdateCoachingSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SchedulingSuccessModalUpdateCoachingSessionMutation,
    SchedulingSuccessModalUpdateCoachingSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SchedulingSuccessModalUpdateCoachingSessionMutation,
    SchedulingSuccessModalUpdateCoachingSessionMutationVariables
  >(SchedulingSuccessModalUpdateCoachingSessionDocument, options);
}
export type SchedulingSuccessModalUpdateCoachingSessionMutationHookResult =
  ReturnType<typeof useSchedulingSuccessModalUpdateCoachingSessionMutation>;
export type SchedulingSuccessModalUpdateCoachingSessionMutationResult =
  Apollo.MutationResult<SchedulingSuccessModalUpdateCoachingSessionMutation>;
export type SchedulingSuccessModalUpdateCoachingSessionMutationOptions =
  Apollo.BaseMutationOptions<
    SchedulingSuccessModalUpdateCoachingSessionMutation,
    SchedulingSuccessModalUpdateCoachingSessionMutationVariables
  >;
export const SchedulingSuccessModalRequestIntroMessageDocument = gql`
  mutation SchedulingSuccessModal_requestIntroMessage(
    $coachUrn: CoachUrn!
    $message: String!
    $categoryUrn: CategoryUrn
    $interest: IntroCallInterest!
    $introCallRequested: Boolean!
    $coachingSession: CoachingSessionInputByApplicant
    $packageUrns: [PackageUrn!]
  ) {
    requestIntroMessage(
      coachUrn: $coachUrn
      message: $message
      introCallRequested: $introCallRequested
      categoryUrn: $categoryUrn
      interest: $interest
      coachingSession: $coachingSession
      packageUrns: $packageUrns
    ) {
      id
      coach {
        coachingRelationship {
          id
        }
      }
      coachingSessions {
        id
        startAt
        createdAt
      }
    }
  }
`;
export type SchedulingSuccessModalRequestIntroMessageMutationFn =
  Apollo.MutationFunction<
    SchedulingSuccessModalRequestIntroMessageMutation,
    SchedulingSuccessModalRequestIntroMessageMutationVariables
  >;

/**
 * __useSchedulingSuccessModalRequestIntroMessageMutation__
 *
 * To run a mutation, you first call `useSchedulingSuccessModalRequestIntroMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulingSuccessModalRequestIntroMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulingSuccessModalRequestIntroMessageMutation, { data, loading, error }] = useSchedulingSuccessModalRequestIntroMessageMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      message: // value for 'message'
 *      categoryUrn: // value for 'categoryUrn'
 *      interest: // value for 'interest'
 *      introCallRequested: // value for 'introCallRequested'
 *      coachingSession: // value for 'coachingSession'
 *      packageUrns: // value for 'packageUrns'
 *   },
 * });
 */
export function useSchedulingSuccessModalRequestIntroMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SchedulingSuccessModalRequestIntroMessageMutation,
    SchedulingSuccessModalRequestIntroMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SchedulingSuccessModalRequestIntroMessageMutation,
    SchedulingSuccessModalRequestIntroMessageMutationVariables
  >(SchedulingSuccessModalRequestIntroMessageDocument, options);
}
export type SchedulingSuccessModalRequestIntroMessageMutationHookResult =
  ReturnType<typeof useSchedulingSuccessModalRequestIntroMessageMutation>;
export type SchedulingSuccessModalRequestIntroMessageMutationResult =
  Apollo.MutationResult<SchedulingSuccessModalRequestIntroMessageMutation>;
export type SchedulingSuccessModalRequestIntroMessageMutationOptions =
  Apollo.BaseMutationOptions<
    SchedulingSuccessModalRequestIntroMessageMutation,
    SchedulingSuccessModalRequestIntroMessageMutationVariables
  >;
export const SchedulingSuccessModalAssignPendingOrderDocument = gql`
  mutation SchedulingSuccessModal_AssignPendingOrder(
    $coachUrn: CoachUrn!
    $orderUrn: OrderUrn!
  ) {
    assignPendingOrder(coachUrn: $coachUrn, orderUrn: $orderUrn) {
      id
    }
  }
`;
export type SchedulingSuccessModalAssignPendingOrderMutationFn =
  Apollo.MutationFunction<
    SchedulingSuccessModalAssignPendingOrderMutation,
    SchedulingSuccessModalAssignPendingOrderMutationVariables
  >;

/**
 * __useSchedulingSuccessModalAssignPendingOrderMutation__
 *
 * To run a mutation, you first call `useSchedulingSuccessModalAssignPendingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulingSuccessModalAssignPendingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulingSuccessModalAssignPendingOrderMutation, { data, loading, error }] = useSchedulingSuccessModalAssignPendingOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      orderUrn: // value for 'orderUrn'
 *   },
 * });
 */
export function useSchedulingSuccessModalAssignPendingOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SchedulingSuccessModalAssignPendingOrderMutation,
    SchedulingSuccessModalAssignPendingOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SchedulingSuccessModalAssignPendingOrderMutation,
    SchedulingSuccessModalAssignPendingOrderMutationVariables
  >(SchedulingSuccessModalAssignPendingOrderDocument, options);
}
export type SchedulingSuccessModalAssignPendingOrderMutationHookResult =
  ReturnType<typeof useSchedulingSuccessModalAssignPendingOrderMutation>;
export type SchedulingSuccessModalAssignPendingOrderMutationResult =
  Apollo.MutationResult<SchedulingSuccessModalAssignPendingOrderMutation>;
export type SchedulingSuccessModalAssignPendingOrderMutationOptions =
  Apollo.BaseMutationOptions<
    SchedulingSuccessModalAssignPendingOrderMutation,
    SchedulingSuccessModalAssignPendingOrderMutationVariables
  >;
